import { render } from "./OpenMei.vue?vue&type=template&id=f815f530&scoped=true"
import script from "./OpenMei.vue?vue&type=script&lang=js"
export * from "./OpenMei.vue?vue&type=script&lang=js"

import "./OpenMei.vue?vue&type=style&index=0&id=f815f530&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f815f530"]])

export default __exports__